import { Component, OnInit, Output, EventEmitter, OnDestroy, ElementRef, Renderer2, Input } from '@angular/core';
import { FormControl } from '@angular/forms';
import { SelectItem } from 'primeng/api';
import moment from 'moment';

@Component({
  selector: 'app-custom-datetime-picker',
  templateUrl: './custom-datetime-picker.component.html',
  styleUrls: ['./custom-datetime-picker.component.scss']
})
export class CustomDateTimePickerComponent implements OnInit, OnDestroy {
  selectedDate: Date | null | any = null;
  times: SelectItem[] = [];
  selectedTime: string | null = "00:00";
  selectedTime2: string | null = "00:00";
  selectedDateTime: string = '';
  showDateTimePicker: boolean = false;
  @Input() dateTimeControl: FormControl = new FormControl();
  @Input() placeHolder = "";
  @Input() properties!: { dateRange?: boolean, timeRange?: boolean, style?: string }
  @Output() dateTimeChange = new EventEmitter<string>();
  
  constructor(private el: ElementRef, private renderer: Renderer2) { }

  clickListener!: () => void;

  ngOnInit() {
    if (!this.properties) {
      this.properties = { dateRange: false, timeRange: false, style: "" }
      this.properties.style = "height:38px";
    }

    this.generateTimeOptions();
    this.setIntialDateTime();
    this.clickListener = this.renderer.listen('document', 'click', this.handleClickOutside.bind(this));

  }

  generateTimeOptions() {
    for (let hour = 0; hour < 24; hour++) {  // Start at 00:00 and go up to 23:30
      // Push 00 minutes
      this.times.push({
        label: this.formatTime(hour, 0),
        value: this.formatTime(hour, 0)
      });

      // Push 30 minutes
      this.times.push({
        label: this.formatTime(hour, 30),
        value: this.formatTime(hour, 30)
      });
    }
  }

  formatTime(hour: number, minute: number): string {
    return `${this.pad(hour)}:${this.pad(minute)}`;  // Ensures double-digit time
  }

  pad(num: number): string {
    return num < 10 ? '0' + num : num.toString(); // Pad single digit numbers with leading 0
  }

  onCancel() {
    this.selectedDate = null;
    this.selectedTime = "00:00";
    this.showDateTimePicker = false;
  }

  onApply() {
    if (!this.properties?.dateRange) {
      const date = this.selectedDate ? moment(this.selectedDate).format('DD/MM/YYYY') : moment().format('DD/MM/YYYY');
      const time = this.selectedTime ? this.selectedTime : '';
      this.selectedDateTime = `${date} ${time}`;
      this.dateTimeControl.setValue(this.selectedDateTime);
      this.dateTimeChange.emit(this.selectedDateTime);
      this.showDateTimePicker = false;
    } else {
      this.selectedDateTime = this.selectedDate ?
        `${moment(this.selectedDate[0]).format('DD/MM/YYYY')}, ${this.selectedTime} - ${moment(this.selectedDate[1]).format('DD/MM/YYYY')}, ${this.selectedTime2}`
        : '';
      this.dateTimeControl.setValue(this.selectedDateTime);
      this.dateTimeChange.emit(this.selectedDateTime);
      this.showDateTimePicker = false;
    }
  }

  setIntialDateTime() {
    if (this.dateTimeControl.value) {
      this.selectedDate = this.dateTimeControl.value;
      this.selectedTime = moment(this.dateTimeControl.value).format('HH:mm');
      const date = this.selectedDate ? moment(this.selectedDate).format('DD/MM/YYYY') : moment().format('DD/MM/YYYY');
      this.selectedDateTime = `${date}, ${this.selectedTime}`;
    }
    this.dateTimeControl.setValue(this.selectedDateTime);
    this.dateTimeChange.emit(this.selectedDateTime);
  }


  toggleDateTimePicker() {
    this.showDateTimePicker = !this.showDateTimePicker;
  }

  ngOnDestroy() {
    if (this.clickListener) {
      this.clickListener();
    }
  }

  handleClickOutside(event: Event) {
    const target = event.target as HTMLElement;
    const isArrowElement = target.classList.contains('p-datepicker-prev') || target.classList.contains('p-datepicker-next');

    // Exclude arrow elements and their children from closing the date picker
    if (!this.el.nativeElement.contains(event.target) && !isArrowElement && !target.closest('.p-datepicker-prev') && !target.closest('.p-datepicker-next')) {
      this.showDateTimePicker = false;
    }
  }
}
